import {
  RelatorioUnidadesPdfResponse,
  RelatorioUnidadesFields,
} from "core/features/relatorios/typings";
import { PDFLayout } from "ui/components/PDF";
import PDFTable from "ui/components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import colors from "theme/colors";
import moment from "moment";
import { formatItemsForPdf } from "./../util/helper";
import useRelatorioUnidadesPdfColumns from "./hooks/useRelatorioUnidadesPdfColumns";
interface PDFRelatorioUnidadesProps {
  data?: RelatorioUnidadesPdfResponse;
  selectedFields?: RelatorioUnidadesFields[];
}

function PDFRelatorioUnidades({
  data,
  selectedFields,
}: PDFRelatorioUnidadesProps) {
  const columns = useRelatorioUnidadesPdfColumns(selectedFields);

  const items = formatItemsForPdf(data?.items);

  const observacoes:
    | { index: number; observacao: string | null }[]
    | undefined = selectedFields?.includes("observacao")
    ? items.reduce((acc, current, index) => {
        const next = items[index + 1];

        if (next?.unidadeId !== current.unidadeId && !!current.observacao) {
          acc.push({
            index,
            observacao: `Observação (Unidade ${current.unidade}): ${current.observacao} `,
          });
        }

        return acc;
      }, [] as { index: number; observacao: string | null }[])
    : [];

  return (
    <PDFLayout
      fontSize={8}
      orientation="landscape"
      assinaturas={data?.assinaturas}
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        title: `Relatório de Unidades`,
        subTitle: `Emitido em ${moment().format(
          "DD/MM/YYYY [às] HH:mm [horas]"
        )}`,
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
    >
      <View>
        <PDFTable
          data={items}
          columns={columns}
          tableHeaderVariant="rowLike"
          extraRows={observacoes?.map((o) => ({
            component: (
              <Text
                style={{ fontWeight: "medium", marginTop: 2, marginBottom: 6 }}
              >
                {o.observacao}
              </Text>
            ),
            index: o.index,
          }))}
        />

        {data ? (
          <View
            style={{
              borderTopColor: colors.primary,
              borderTopWidth: 2,
              paddingTop: 2,
              fontWeight: "medium",
            }}
          >
            <Text>Total de pessoas: {data.totalPessoas}</Text>
          </View>
        ) : null}
      </View>
    </PDFLayout>
  );
}

export default PDFRelatorioUnidades;
